export const color = {
	brand: '',
	secondary: '',
	secondaryLight: '',
	secondaryLighter: '',
	onSecondary: '',
	onPrimary: '',
	primaryLight: '',
	focusOutline: '',

	highlight: '',
	background: {
		default: '#fff',
		light: '',
		hover: '',
	},
	text: {
		default: '#000',
		light: '',
		inverted: '',
		hover: '',
	},
	border: {
		default: '',
	},
	state: {
		warning: '',
		error: '',
		success: '',
		hover: '',
	},
};
